import '../../App.css'
import { useEffect, useRef, useState } from 'react';
import { Drawer, Input, Modal, Pagination, Spin, Table } from 'antd';
import axios from 'axios';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { useSelector, useDispatch } from 'react-redux';
import LeftSidebar, { mainMenu } from 'components/leftSidebar';
import { getLoginTokenAsync, loginUserAsync, logout, setProfileData } from '../../redux/slice/auth/authSlice';
import Appconfig from '../../config/config'
import { getUserBalanceAsync } from '../../redux/slice/user/userSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { fetchNewsListAsync } from '../../redux/slice/news/newsSlice';
import Loader from 'components/loader';
import { fetchAllOpenBets } from '../../redux/slice/openBets/openBetsSlice';
import WebSocketEventEmitter from 'context/eventEmitter';
import { fetchUserProfile } from 'services/users';


function Header({ rightMenu, setRightMenu, leftMenu, setLeftMenu, isLoginModalOpen, setIsLoginModalOpen }) {
    const { userdata, loading, isAuthenticated, loginToken } = useSelector((state) => state.authSlice);
    const { openBets, loading: openBetsLoading, error: openBetsError } = useSelector((state) => state.openBets);
    const [Loading, setLoading] = useState(false);
    const profileData = useSelector((state) => state.authSlice.profileData);
    const { newsList } = useSelector((state) => state.news);
    const [currentNews, setCurrentNews] = useState('');
    const { userBalance } = useSelector((state) => state.userbal);
    const [isBetsModalOpen, setIsBetsModalOpen] = useState(false);
    const location = useLocation();
    const userNavItems = [
        {
            'title': 'In-Play',
            'url': '/inplay',
            'classes': 'inplaymobile',
            'icon': '/assets/svg/inplay.svg',
        },
        {
            'title': 'IPL 2025',
            'url': '/ipl',
            'classes': 'inplaymobile ',
            'highlight': true,
            'icon': '/assets/svg/wpl.svg'
        },
        // {
        //     'title': 'ICC Champions 2025',
        //     'url': '/icc2025',
        //     'classes': 'iplwinnertablet',
        //     'highlight': true
        // },
        {
            'title': 'Cricket',
            'url': '/game/4',
            'live': 0,
            'classes': 'cricketmobile',

        },
        {
            'title': 'Soccer',
            'url': '/game/1',
            'live': 0,
            'classes': 'soccermobile',
        },
        {
            'title': 'Tennis',
            'url': '/game/2',
            'live': 1,
            'classes': 'tennismobile',
        },
        // {
        //     'title': 'Horse',
        //     'url': '/game/7',
        //     'live': 1,
        //     'classes': 'horsemobile',
        // },
        // {
        //     'title': 'Greyhound',
        //     'url': '/game/4339',
        //     'live': 0,
        //     'classes': 'greyhoundmobile',
        // },
        // {
        //     'title': 'LudoCricket',
        //     'url': '/ludocricket',
        //     'classes': 'casinomobile',
        // },
        {
            'title': 'Indian Poker',
            'url': '/royalcasino',
            'classes': 'casinomobile',
        },
        {
            'title': 'Indian Poker II',
            'url': '/indianpoker',
            'classes': 'indianpokermobile',
        },
        {
            'title': 'Aviator',
            'url': '/spribe',
            'img': '/assets/svg/aviator.svg',
        },
        {
            'title': 'AE SEXY',
            'url': '/aesexybcrt',
            'classes': 'casinomobile',
        },
        {
            'title': 'Evolution',
            'url': '/evolution'
        },
        {
            'title': 'Live Casino',
            'url': '/livecasino',
            'classes': 'casinomobile',
        },
        // {
        //     'title': 'Vivo',
        //     'url': '/vivo',
        //     'classes': 'casinomobile',
        // },
        // {
        //     'title': 'Betgames',
        //     'url': '/betgames',
        //     'classes': 'casinomobile',
        // },
        {
            'title': 'Casino III',
            'url': '/casino3',
            'classes': 'casinomobile',
        },

    ]
    const downlineListItem = {
        'title': 'Downline List ',
        'url': '',
        'routerId': ['/list/user', '/list/master'],
        'submenu': Appconfig.userTypes.slice(Appconfig.userTypes.findIndex(userType => userType?.title == userdata?.user_type) + 1)?.map(userType => ({
            title: userType?.title,
            url: `list/${profileData?._id}/${userType?.title}`
        })) || []
    };

    // const downlineListItem = {
    //     'title': 'Downline List ',
    //     'url': '',
    //     'routerId': ['/list/user', '/list/master'],
    //     'submenu': [
    //         { 'title': 'User Downline List', 'url': '/list/user' },
    //         // { 'title': 'Master Downline List', 'url': '/list/master' }
    //     ]
    // };


    const initialNavItems = [
        {
            'title': 'Dashboard ',
            'url': '/dashboard',
            'routerId': ['/dashboard'],
        },
        downlineListItem,
        {
            'title': 'My Account ',
            'url': '/my-account',
            'routerId': ['/my-account'],
        },
        {
            'title': 'My Report',
            'url': '',
            'routerId': ['/reports/profit-loss', '/reports/downline-pl'],
            'submenu': [
                {
                    'title': 'Account Statement ',
                    'url': '/accountstatement'
                },
                {
                    'title': 'Market Analysis ',
                    'url': '/market-analysis'
                },
                {
                    'title': 'Profit Loss Report ',
                    'url': '/profitloss'
                },
                {
                    'title': 'Bet Histroy ',
                    'url': '/bethistroy'
                },
                {
                    'title': 'Client P L ',
                    'url': '/clientpl'
                },
                {
                    'title': 'Market P L ',
                    'url': '/marketpl'
                },
                {
                    'title': 'Sport P L ',
                    'url': '/sportpl'
                },
                {
                    'title': 'Match P L ',
                    'url': '/matchpl'
                },
                {
                    'title': 'Fancy Sale',
                    'url': '/fancy-sale'
                },
                {
                    'title': 'Match Sale',
                    'url': '/match-sale'
                },
                {
                    'title': 'Chip Summary',
                    'url': '/chipsummary'
                }
            ]
        },
        // {
        //     'title': 'BetList ',
        //     'url': '/bet-list',
        //     'routerId': ['/bet-list'],
        // },
        {
            'title': 'Market Analysis ',
            'url': '/market-analysis',
            'routerId': ['/market-analysis'],
        },
        {
            'title': 'Banking',
            'url': '',
            'routerId': ['/user-banking', '/master-banking'],
            'submenu': [
                {
                    'title': 'User Banking',
                    'url': '/user-banking'
                },
                // {
                //     'title': 'Master Banking',
                //     'url': '/master-banking'
                // },
            ]
        },
        // {
        //     'title': 'Commission ',
        //     'url': '/commission',
        //     'routerId': ['/commission'],
        // },
        {
            'title': 'Password History',
            'url': '/password-history',
            'routerId': ['/password-history'],
        },

    ];
    let navItems = [...initialNavItems];

    const downlineListItem1 = {
        'title': 'Downline List ',
        'url': '',
        'routerId': ['/list/user', '/list/master'],
        'submenu': [
            // {
            //     'key': '1', 'label': (
            //         <Link to={'/list/user'}>
            //             User Downline List
            //         </Link>
            //     )
            // },
            // {
            //     'key': '2', 'label': (
            //         <Link to={`/list/master`}>
            //             Master Downline List
            //         </Link>
            //     )
            // }
        ]
    };

    const initialNavItemsForMobile = [
        {
            'title': 'Dashboard ',
            'url': '/dashboard',
            'routerId': ['/dashboard'],
        },
        downlineListItem1,
        {
            'title': 'My Account ',
            'url': '/my-account',
            'routerId': ['/my-account'],
        },
        // {
        //     'title': 'My Report',
        //     'url': '',
        //     'routerId': ['/reports/profit-loss', '/reports/downline-pl'],
        //     'submenu': [
        //         {
        //             key: '1',
        //             label: (
        //                 <Link to={'/reports/profit-loss'}>
        //                     Event Profit/Loss
        //                 </Link>
        //             ),
        //         },
        //         {
        //             key: '2',
        //             label: (
        //                 <Link to={'/reports/downline-pl'}>
        //                     Downline Profit/Loss
        //                 </Link>
        //             ),
        //         },
        //     ]
        // },
        // {
        //     'title': 'BetList ',
        //     'url': '/bet-list',
        //     'routerId': ['/bet-list'],
        // },
        {
            'title': 'Market Analysis ',
            'url': '/market-analysis',
            'routerId': ['/market-analysis'],
        },
        {
            'title': 'Banking',
            'url': '',
            'routerId': ['/user-banking', '/master-banking'],
            'submenu': [
                {
                    key: '1',
                    label: (
                        <Link to={'/user-banking'}>
                            User Banking
                        </Link>
                    ),
                },
                // {
                //     key: '2',
                //     label: (
                //         <Link to={'/master-banking'}>
                //             Master Banking
                //         </Link>
                //     ),
                // },
            ]
        },
        // {
        //     'title': 'Commission ',
        //     'url': '/commission',
        //     'routerId': ['/commission'],
        // },
        {
            'title': 'Password History',
            'url': '/password-history',
            'routerId': ['/password-history'],
        },
        // {
        //     'title': 'Restore User ',
        //     'url': '/restore-user',
        //     'routerId': ['/restore-user'],
        // },
    ]

    let navItemsForMobile = [...initialNavItemsForMobile];

    // if (['Managment', 'Administrative'].includes(userdata?.user_type)) {
    navItems.push(
        {
            'title': 'Restore User',
            'url': '/restore-user',
            'routerId': ['/restore-user'],
        },
        {
            'title': 'My Setting',
            'url': '',
            'routerId': ['/adminfund', '/news', `/user-general-setting/${profileData?._id}`, `/block-event-types`, `/event-user-general-setting`, `/add-domain`, `/betting`, `/banner`, `/manual-odds`],
            'submenu': [
                (['Managment', 'Administrative'].includes(userdata?.user_type) &&

                {
                    'title': 'Admin Fund ',
                    'url': '/adminfund'
                }
                ),
                {
                    'title': 'News ',
                    'url': '/news'
                },
                {
                    'title': 'User General Setting ',
                    'url': `/user-general-setting/${profileData?._id}`
                },
                {
                    'title': 'Block Market ',
                    'url': '/block-event-types'
                },
                {
                    'title': 'Event Wise Setting ',
                    'url': `/event-user-general-setting`
                },
                // {
                //     'title': 'Add Domain ',
                //     'url': `/add-domain`
                // },
                {
                    'title': 'Betting ',
                    'url': `/betting`
                },
                {
                    'title': 'Add Banner ',
                    'url': `/banner`
                },
                // {
                //     'title': 'Manual Odds ',
                //     'url': `/manual-odds`
                // },
            ]
        });
    navItemsForMobile.push(
        {
            'title': 'My Setting',
            'url': '',
            'routerId': ['/adminfund', '/news', `/user-general-setting/${profileData?._id}`, `/event-user-general-setting`, `/add-domain`],
            'submenu': [
                {
                    key: '1',
                    label: (
                        <Link to={'/adminfund'}>
                            Admin Fund
                        </Link>
                    ),
                },
                {
                    key: '2',
                    label: (
                        <Link to={'/news'}>
                            News
                        </Link>
                    ),
                },
                {
                    key: '3',
                    label: (
                        <Link to={`/user-general-setting/${profileData?._id}`}>
                            User General Setting
                        </Link>
                    ),
                },
                {
                    key: '4',
                    label: (
                        <Link to={'/block-event-types'}>
                            Block Market
                        </Link>
                    ),
                },
                {
                    key: '5',
                    label: (
                        <Link to={'/event-user-general-setting'}>
                            Event Wise User General Setting
                        </Link>
                    ),
                },
                {
                    key: '6',
                    label: (
                        <Link to={'/add-domain'}>
                            Add Domain
                        </Link>
                    ),
                },
                {
                    key: '7',
                    label: (
                        <Link to={'/betting'}>
                            Betting
                        </Link>
                    ),
                },
                {
                    key: '8',
                    label: (
                        <Link to={'/banner'}>
                            Add Banner
                        </Link>
                    ),
                },
                {
                    key: '9',
                    label: (
                        <Link to={'/manual-odds'}>
                            Manual Odds
                        </Link>
                    ),
                },
            ]
        },
    )
    // }

    // if (userdata?.user_type === 'Admin') {
    //     navItems.push({
    //         'title': 'Extra',
    //         'url': '',
    //         'routerId': ['/adminfund', '/news', `/user-general-setting/${profileData?._id}`],
    //         'submenu': [
    //             {
    //                 'title': 'News',
    //                 'url': '/news'
    //             },
    //             {
    //                 'title': 'Add Banner',
    //                 'url': `/banner`
    //             },
    //             {
    //                 'title': 'User General Setting',
    //                 'url': `/user-general-setting/${profileData?._id}`
    //             },
    //             {
    //                 'title': 'Event Wise Setting ',
    //                 'url': `/event-user-general-setting`
    //             },
    //             {
    //                 'title': 'Block Market ',
    //                 'url': '/block-event-types'
    //             },
    //             {
    //                 'title': 'Admin Fund ',
    //                 'url': '/adminfund'
    //             },
    //         ]
    //     });
    //     navItemsForMobile.push(
    //         {
    //             'title': 'Extra',
    //             'url': '',
    //             'routerId': ['/adminfund', '/news', `/user-general-setting/${profileData?._id}`, `/event-user-general-setting`],
    //             'submenu': [

    //                 {
    //                     key: '2',
    //                     label: (
    //                         <Link to={'/news'}>
    //                             News
    //                         </Link>
    //                     ),
    //                 },
    //                 {
    //                     key: '8',
    //                     label: (
    //                         <Link to={'/banner'}>
    //                             Add Banner
    //                         </Link>
    //                     ),
    //                 },
    //                 {
    //                     key: '10',
    //                     label: (
    //                         <Link to={`/user-general-setting/${profileData?._id}`}>
    //                             User General Setting
    //                         </Link>
    //                     ),
    //                 },
    //             ]
    //         },
    //     )
    // }


    const [loginCredentials, setLoginCredentials] = useState({
        user_name: '',
        password: ''
    });
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const [rememberMe, setRememberMe] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setLoginCredentials(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!loginCredentials.user_name || !loginCredentials.password) {
            NotificationManager.error('Please enter both User ID and Password', '', 1000);
            return;
        }
        try {
            const result = await dispatch(loginUserAsync({
                user_name: loginCredentials.user_name.toLowerCase(),
                password: loginCredentials.password,
                site_code: Appconfig.sitecodes,
            })).unwrap();
            NotificationManager.success('Login Successful', '', 1000);
            setLoginCredentials({
                user_name: '',
                password: ''
            });
            if (result.userdata?.user_type !== 'User') {
                navigate('/dashboard');
            } else {
                navigate('/');
            }
            setIsLoginModalOpen(false);
        } catch (error) {
            NotificationManager.error(error || 'Login failed. Please try again.', '', 1000);
        }
    };
    const handleLogout = (item) => {
        if (item.isLogout) {
            dispatch(logout());
            navigate('/');
            setRightMenu(false)
        }
    };

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(getUserBalanceAsync());
        }
    }, [isAuthenticated])

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchNewsListAsync({ site_id: Appconfig.sitecodes }));
        }
    }, [dispatch, isAuthenticated]);

    useEffect(() => {
        if (newsList?.length) {
            const newsMessages = newsList.map(news => news.message).join('  ');
            setCurrentNews(newsMessages);
        }
    }, [newsList]);



    const handleDemoLogin = async (e) => {
        e.preventDefault();
        try {
            const result = await dispatch(loginUserAsync({
                user_name: 'demo_user',
                password: '123456',
                site_code: Appconfig.sitecodes,
            })).unwrap();
            NotificationManager.success('Login Successful', '', 1000);
            setLoginCredentials({
                user_name: '',
                password: ''
            });
            if (result.userdata?.user_type !== 'User') {
                navigate('/dashboard');
            } else {
                navigate('/');
            }
            setIsLoginModalOpen(false);
        } catch (error) {
            NotificationManager.error(error || 'Login failed. Please try again.', '', 1000);
        }
    };

    const columns = [
        // {
        //     title: 'Competition',
        //     dataIndex: 'competition',
        //     // sorter: true,
        //     width: '5%',
        //     render: (_, record) => (
        //         <span className="">{record?.competition}</span>
        //     ),
        //     // render: (name) => `${name.first} ${name.last}`,
        // },
        {
            title: 'Event',
            dataIndex: 'event',
            // sorter: true,
            width: '20%',
            render: (_, record) => (
                <span className="">{record?.event_name}</span>
            ),
            // render: (name) => `${name.first} ${name.last}`,
        },
        {
            title: 'Market',
            dataIndex: 'market',
            // sorter: true,
            width: '8%',
            render: (_, record) => (
                <span className="">{record?.market_name}</span>
            ),
            // render: (name) => `${name.first} ${name.last}`,
        },
        {
            title: 'Runner',
            dataIndex: 'runner',
            // sorter: true,
            width: '9%',
            render: (_, record) => (
                <span className="">{record?.runner_name}</span>
            ),
            // render: (name) => `${name.first} ${name.last}`,
        },
        {
            title: 'Side',
            dataIndex: 'side',
            // sorter: true,
            width: '7%',
            render: (_, record) => (
                <span className="">{record?.is_back ? 'Back' : 'Lay'}</span>
            ),
            // render: (name) => `${name.first} ${name.last}`,
        },
        {
            title: 'Line',
            dataIndex: 'line',
            // sorter: true,
            align: 'right',
            width: '7%',
            render: (_, record) => (
                <span className="">{record?.line}</span>
            ),
            // render: (name) => `${name.first} ${name.last}`,
        },
        {
            title: 'Rate',
            dataIndex: 'rate',
            align: 'right',
            // sorter: true,
            width: '7%',
            render: (_, record) => (
                <span className="">{record?.price_val ? Number(record?.price_val).toFixed(2) : '-'}</span>
            ),
            // render: (name) => `${name.first} ${name.last}`,
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            align: 'right',
            width: '7%',
            render: (_, record) => (
                <span className="">{record?.stake ? Number(record?.stake).toFixed(2) : '-'}</span>
            ),
            // render: (name) => `${name.first} ${name.last}`,
        },
        {
            title: 'PP',
            dataIndex: 'pl',
            align: 'right',
            width: '7%',
            render: (_, record) => (
                <span className="text-[green]">{record?.profit ? Number(record?.profit).toFixed(2) : '-'}</span>
            ),
            // render: (name) => `${name.first} ${name.last}`,
        },
        {
            title: 'PL',
            dataIndex: 'pl',
            align: 'right',
            width: '7%',
            render: (_, record) => (
                <span className="text-[red]">{record?.pl ? Number(record?.pl).toFixed(2) : '-'}</span>
            ),
            // render: (name) => `${name.first} ${name.last}`,
        },
    ];

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchAllOpenBets());
        }
    }, [isAuthenticated, dispatch]);

    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [filteredData, setFilteredData] = useState();
    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    // const paginatedData = openBets && openBets.slice(startIndex, endIndex);
    const paginatedData = filteredData?.slice(startIndex, endIndex);
    const locale = {
        emptyText: (
            <h5 className="!text-[#c7313f] !font-bold !m-0 text-[1.2rem] leading-[1.2]">No Unsettled Bets</h5>
        )
    }
    useEffect(() => {
        if (openBets) {
            setFilteredData(openBets)
        }
    }, [openBets])

    useEffect(() => {
        const chkLog = window.setInterval(function () {
            if (userdata) {
                checkNewLogin();
            }
        }, 5000);
        return () => {
            clearInterval(chkLog)
        }
    }, [userdata])
    const checkNewLogin = () => {
        const token = localStorage.getItem('token');
        var data = {
            "login_token": token,
        };
        var config = {
            method: 'post',
            url: `${Appconfig.apiUrl}api/auth/get-login-token`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: JSON.stringify(data)
        };
        axios(config)
            .then(function (response) {
                try {
                    if (response) {
                        if (JSON.stringify(token) !== JSON.stringify(response?.data?.data?.login_token)) {
                            dispatch(logout());
                            navigate('/');
                        }
                    }
                } catch (e) {
                    console.log(e)
                    // postErrorToslack(e.message);
                }
            })
            .catch(function (error) {
                // postErrorToslack(error.message);
                console.log(error);
            });
    }

    useEffect(() => {
        const handleMessage = async (data) => {
            if (data.action == "USER_BLOCK_UPDATE") {
                let market = data.data;
                console.log("user block Details SOCKET RESPONDING");
                if (market) {
                    const profileResponse = await fetchUserProfile();
                    dispatch(setProfileData(profileResponse?.data?.data));
                }
            }
        };

        WebSocketEventEmitter.on("message", handleMessage);

        return () => {
            WebSocketEventEmitter.off("message", handleMessage); // Cleanup on unmount
        };
    }, [profileData, dispatch])

    function CreateAndLaunchWCOCasino(provider_code, game_code, type) {
        if (!isAuthenticated) {
            NotificationManager.error('Please login to play.', '', 1000);
            return;
        }
        setLoading(true);
        if (profileData?.is_casino_bet_lock == 'Yes') {
            NotificationManager.error('Casino Block By Upline.', '', 1000);
            setLoading(false);
            return;
        }
        const userData = {
            user_id: profileData?._id,
            user_name: profileData?.user_name,
            redirect_url: window.location.href,
            provider_code: provider_code,
            game_code: game_code,
            type: type,
        };

        var config = {
            method: "post",
            url: `${Appconfig.casinoUrl}wco/login`,
            headers: {
                "Content-Type": "application/json",
            },

            data: JSON.stringify(userData),
        };

        axios(config)
            .then(function (response) {
                let status = response.data.status?.code;
                console.log('status:', status)
                if (status === "SUCCESS") {
                    window.open(response.data.launchURL, "_self");
                    setLoading(false);
                }

                if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
                    NotificationManager.error('Game Not Found.', '', 1000);
                    setLoading(false);
                } else if (status == "AUTHENTICATION_FAILED") {
                    NotificationManager.error(response.data.status?.message, '', 1000);
                    setLoading(false);
                }
                if (status == "LOGIN_FAILED") {
                    NotificationManager.error(response?.data?.status?.message, '', 1000);
                    setLoading(false);
                }
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    }
    return (
        <>
            {(loading || Loading) && <Loader />}
            <div className='h-auto p-0  w-full '>
                <div className='flex justify-between items-center  flex-wrap bg-[#045662] !h-[25px] px-[5px] py-[3px] !relative !w-full'>
                    <div className='w-[70%] md:w-[85%] lg:w-[92%]'>
                        <div className='text-[#fff] flex relative'>
                            <span className='bg-[#045662] inline-block left-[0]  -top-[2px] w-[22px]'>
                                <i className="fa fa-bullhorn" aria-hidden="true"></i>
                            </span>
                            <marquee behavior="" direction="left">{currentNews}</marquee>
                        </div>
                    </div>
                    <div className='w-[30%] md:w-[15%] lg:w-[8%]'>
                        <div className='items-center flex !float-right'>
                            <div className='text-[12px] justify-end items-center flex text-[#fff]'>
                                <span className='-mt-[5px]'>{new Date().toLocaleString()}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <header className='p-0 bg-[#18b0c8] bg-[linear-gradient(#022c43,_#18b0c8)] h-auto relative top-[0] w-full block'>
                    <div className="ml-auto mr-auto pl-[15px] pr-[15px] w-full">
                        <div className='flex flex-wrap -ml-[15px] -mr-[15px]'>
                            {/* logo div */}
                            <div className='pl-[15px] pr-[15px] relative w-full flex-[0_0_50%] max-w-[50%] [@media(min-width:576px)]:flex-[0_0_50%] [@media(min-width:576px)]:max-w-[50%] md:flex-[0_0_41.666667%] md:max-w-[41.666667%] [@media(min-width:992px)]:flex-[0_0_33.333333%] [@media(min-width:992px)]:max-w-[33.333333%] [@media(min-width:1200px)]:flex-[0_0_25%] [@media(min-width:1200px)]:max-w-[25%]'>
                                <div className='items-center flex px-[0] py-[9px]'>
                                    <button type="button" onClick={() => setLeftMenu(true)}>
                                        <i className="fa fa-bars icon-toggle-right cls-bx-menu baricon"></i>
                                    </button>
                                    <Link to={'/'} className="inline">
                                        <img src="/assets/logo/logo.webp" width="195" height="60" alt="logo" className="loginlogo h-[50px] lg:h-[60px]" />
                                    </Link>
                                </div>
                            </div>
                            {
                                !isAuthenticated ?
                                    <div className='items-center flex pl-[15px] pr-[15px] relative w-full justify-end flex-[0_0_50%] max-w-[50%] [@media(min-width:576px)]:flex-[0_0_50%] [@media(min-width:576px)]:max-w-[50%] md:flex-[0_0_58.333333%] md:max-w-[58.333333%] [@media(min-width:992px)]:flex-[0_0_66.666667%] [@media(min-width:992px)]:max-w-[66.666667%] [@media(min-width:1200px)]:flex-[0_0_75%] [@media(min-width:1200px)]:max-w-[75%]'>
                                        <div>
                                            <ul>
                                                <li className='relative inline-block ml-[0] lg:mr-[5px] my-[0] [list-style:none]'>
                                                    <button type="button" className='bg-[#5ecbdd] bg-[linear-gradient(#5ecbdd,_#146578)]  border-[1px] border-solid border-[#72bbef] rounded-[10px] !text-[#fff] text-[12px] lg:text-[14px] font-bold leading-[26px] lg:px-[15px] py-[3px] px-[12px] lg:py-[5px] text-center uppercase' onClick={() => setIsLoginModalOpen(true)}>
                                                        <i className="fa fa-user mr-1" aria-hidden="true"></i>
                                                        Log in
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    :
                                    <div className='items-center flex pl-[15px] pr-[15px] relative w-full justify-end flex-[0_0_50%] max-w-[50%] [@media(min-width:576px)]:flex-[0_0_50%] [@media(min-width:576px)]:max-w-[50%] md:flex-[0_0_58.333333%] md:max-w-[58.333333%] [@media(min-width:992px)]:flex-[0_0_66.666667%] [@media(min-width:992px)]:max-w-[66.666667%] [@media(min-width:1200px)]:flex-[0_0_75%] [@media(min-width:1200px)]:max-w-[75%]'>
                                        <div className="grid">
                                            <i className="hidden" id="btnHdnRecalculateDemoExpo"></i>
                                            <button type="button" id="btnExpoRightMenu" className="rounded-[7px] flex items-center justify-center text-[14px] h-auto leading-[16px] min-w-[100px] px-[8px] py-[3px] w-auto mb-[3px] bg-[linear-gradient(#5ecbdd,_#146578)] border-[1px] border-[solid] border-[#72bbef] !ml-[.25rem]" onClick={() => setRightMenu(true)}>
                                                <span className="relative z-0 text-[#fff]">
                                                    <img src="/assets/svg/coin.svg" className="relative w-[21px] !pr-[.25rem] max-w-full" alt="" />
                                                </span>
                                                <span className="!pl-[2px] text-[#fff]">{userBalance?.balance}</span>
                                            </button>
                                            <button type="button" id="btnExpoRightMenu" className="rounded-[7px] flex items-center justify-center text-[14px] h-auto leading-[16px] min-w-[100px] px-[8px] py-[3px] w-auto mb-[3px] bg-[linear-gradient(#5ecbdd,_#146578)] border-[1px] border-[solid] border-[#72bbef] !ml-[.25rem]" onClick={() => setRightMenu(true)}>
                                                <span className="text-[#fff] text-[12px] font-bold">Exp :</span>
                                                <span className="!pl-[2px] text-[#fff]">{userBalance?.exposure}</span>
                                            </button>
                                        </div>
                                    </div>
                            }

                            <Modal centered className='!max-w-[94%] lg:!max-w-[460px] login-modal' footer={null} open={isLoginModalOpen} onOk={() => setIsLoginModalOpen(false)} onCancel={() => setIsLoginModalOpen(false)}>
                                <div className='!pb-[5px] relative pt-0 overflow-y-auto flex-auto p-4'>
                                    <div>
                                        <h5 className="!text-[#000] opacity-100 font-bold !text-center !mt-0 leading-normal text-[1.25rem] mb-0" >
                                            Login
                                            <button type="button" className="!text-[#000] !opacity-100 cursor-pointer float-right text-[1.25rem]  font-bold leading-none" data-dismiss="modal" aria-hidden="true" onClick={() => setIsLoginModalOpen(false)}>  × </button>
                                        </h5>
                                    </div>
                                    <form onSubmit={handleLogin}>
                                        <div className="mb-[5px]">
                                            <label htmlFor="user_name" className="text-[#000] block text-[14px] mb-0 relative" data-icon="u">User ID</label>
                                            <input
                                                autoFocus
                                                className="bg-[#fff] !outline-none text-[#000] rounded-[10px] h-[35px] text-[14px] w-full items-center border-[1px] border-[solid] border-[#dedede] [box-shadow:0_4px_4px_rgb(0_0_0_/_5%)] flex flex-nowrap p-[5px] [transition:all_.3s] "
                                                name="user_name"
                                                id='user_name'
                                                autoCorrect='off'
                                                maxLength={30}
                                                required
                                                type="text"
                                                placeholder="User ID"
                                                value={loginCredentials.user_name}
                                                onChange={handleInputChange}
                                                style={{ borderColor: '#3f4045' }}
                                            />
                                        </div>
                                        <div className="text-[#000] text-[14px] w-full !mb-[.25rem] !justify-end !flex">
                                            <input
                                                type="checkbox"
                                                className='ml-[4px] mr-[3px] my-[3px]'
                                                name="rememberMe"
                                                checked={rememberMe}
                                                onChange={(e) => setRememberMe(e.target.checked)}
                                            />
                                            <span className="signup-validation-text"> Remember me</span>
                                        </div>
                                        <div className="relative mb-[5px]">
                                            <label htmlFor="password" className="text-[#000] block text-[14px] mb-0 relative" data-icon="p">Password </label>
                                            <input
                                                className="bg-[#fff] !outline-none text-[#000] rounded-[10px] h-[35px] text-[14px] w-full items-center border-[1px] border-[solid] border-[#dedede] [box-shadow:0_4px_4px_rgb(0_0_0_/_5%)] flex flex-nowrap p-[5px] [transition:all_.3s]"
                                                tabIndex={2}
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                id="password"
                                                placeholder="Password"
                                                value={loginCredentials.password}
                                                onChange={handleInputChange}
                                                required
                                                style={{ borderColor: '#3f4045' }}
                                            />
                                            <button
                                                type="button"
                                                className="absolute right-[10px] top-[40px] transform -translate-y-1/2 text-[#a1aed4] text-[14px] focus:outline-none"
                                                onClick={togglePasswordVisibility}
                                            >
                                                {showPassword ? (
                                                    <i className="fa fa-eye"></i>
                                                ) : (
                                                    <i className="fa fa-eye-slash"></i>
                                                )}
                                            </button>
                                        </div>
                                        <div className="relative flex items-center mb-[5px]">
                                        </div>
                                        <div className=" !py-[5px] items-center rounded-bl-[calc(.3rem_-_1px)] rounded-br-[calc(.3rem_-_1px)] flex flex-wrap justify-end" id="content1">
                                            <div className="text-[#000] items-center rounded-[2px] box-border cursor-pointer inline-flex text-[16px] h-[40px] justify-center overflow-hidden p-0 text-center no-underline overflow-ellipsis [transition:all_.5s] whitespace-nowrap w-full m-[.25rem] !mx-auto">
                                                <button type="button" className="bg-[none_repeat_scroll_0_0_#6fe3f5] bg-[linear-gradient(-180deg,_#6fe3f5,_#065265)] border-[1px] border-[solid] border-[#065265] [box-shadow:none] text-[#fff] rounded-[3px] float-right text-[16px] h-[40px] m-0 outline-[none] pt-[3px] px-[10px] pb-[5px] [text-shadow:0_1px_1px_rgba(0,_0,_0,_.5)] [transition:all_.2s_linear_0s] w-full normal-case" disabled={loading}
                                                    onClick={handleLogin}
                                                >
                                                    <span className="">{loading ? 'Logging in...' : 'Login'}</span>
                                                </button>
                                            </div>
                                            <div className="text-[#000] items-center rounded-[2px] box-border cursor-pointer inline-flex text-[16px] h-[40px] justify-center overflow-hidden p-0 text-center no-underline overflow-ellipsis [transition:all_.5s] whitespace-nowrap w-full m-[.25rem] !mx-auto">
                                                <button type='button' className="bg-[none_repeat_scroll_0_0_#6fe3f5] bg-[linear-gradient(-180deg,_#6fe3f5,_#065265)] border-[1px] border-[solid] border-[#065265] [box-shadow:none] text-[#fff] rounded-[3px] float-right text-[16px] h-[40px] m-0 outline-[none] pt-[3px] px-[10px] pb-[5px] [text-shadow:0_1px_1px_rgba(0,_0,_0,_.5)] [transition:all_.2s_linear_0s] w-full normal-case" disabled={loading}
                                                    onClick={handleDemoLogin}
                                                >
                                                    <span className="">Demo ID</span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </Modal>



                            <Drawer className="rightMenu" onClose={() => setRightMenu(false)} open={rightMenu}>
                                <Modal className="bets-modal !max-w-[94%] !w-[89%] !max-h-[calc(100%-1rem)] absolute lg:relative  top-0 lg:top-[30px] left-[10px]" footer={null} open={isBetsModalOpen} onCancel={() => setIsBetsModalOpen(false)}>
                                    <div>
                                        <div class="modal-header">
                                            <h5 class="text-[#fff] text-[1.1rem] font-medium" id="myModalLabel">Unsetteled Bets</h5>
                                            <button type="button" class="ml-[auto] -mr-[1rem] -my-[1rem] p-4 text-[#000] float-right text-[1.5rem] font-bold leading-none opacity-[.5] [text-shadow:0_1px_0_#fff]" data-dismiss="modal" aria-hidden="true" onClick={() => setIsBetsModalOpen(false)}>×</button>
                                        </div>
                                        <div className="flex-auto p-4 pb-0 relative">
                                            <Table
                                                columns={columns}
                                                className=' account-statement'
                                                bordered
                                                dataSource={paginatedData}
                                                pagination={false}
                                            />
                                            <div className='grid grid-cols-12 items-center pt-[1rem] pb-[10px] px-[.5rem]'>
                                                <div className='col-span-12 lg:col-span-6  '>
                                                    Showing {startIndex + 1} - {endIndex} of {filteredData && filteredData.length} entries
                                                </div>
                                                <div className='col-span-12 lg:col-span-6 flex items-center justify-start lg:mt-[0rem]'>
                                                    <Pagination
                                                        locale={locale}
                                                        current={current}
                                                        pageSize={pageSize}
                                                        total={filteredData && filteredData.length}
                                                        onChange={(page) => setCurrent(page)}
                                                        itemRender={(page, type, originalElement) => {
                                                            if (type === 'prev') {
                                                                return <button type='button' className='!cursor-pointer'>Prev</button>;
                                                            }
                                                            // if (type === 'page') {
                                                            //     return null;
                                                            // }
                                                            if (type === 'next') {
                                                                return <button type='button' className='!cursor-pointer'>Next</button>;
                                                            }
                                                            return originalElement;
                                                        }}
                                                        showSizeChanger={false}
                                                    />
                                                    <button type="button" class="border-[#dc3545] text-[#dc3545] border-[1px] ml-[10px] rounded-[.25rem] text-[1rem] font-normal leading-normal px-[10px] py-[3px] text-center" data-dismiss="modal" onClick={() => setIsBetsModalOpen(false)}>Cancel</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Modal>
                                <button type="button" className="text-[36px] leading-[36px] relative text-right w-full block pl-[10px] pr-[8px] py-[8px] no-underline [transition:.3s] text-[#fff]" onClick={() => setRightMenu(false)}>×</button>
                                <span className="text-[14px] pl-[10px] pr-[8px] py-[8px] normal-case text-[#fff]">
                                    <i className="fa fa-user text-[#ffd949] !pr-[.5rem] cmenu" aria-hidden="true"></i>{`${profileData?.name} - (${userBalance?.balance})`}
                                </span>
                                <div className="flex">
                                    <div className="rounded-[3px] [box-shadow:0_1px_1px_0_rgba(0,_0,_0,_.3)] cursor-pointer ml-[4px] mr-[2px] my-[5px] w-[48%] bg-[#17afc6] border-[1px] border-[solid] border-[#fff]">
                                        <dl className="cursor-pointer pt-[5px] px-[7px] pb-[0] !mb-[.25rem] mt-0"
                                            onClick={() => setIsBetsModalOpen(true)}
                                        >
                                            <dt className="leading-[1.6] mb-[3px] text-[#fff] font-bold">Exposure</dt>
                                            <dd className="pb-0 items-center flex font-[Roboto_Condensed,_sans-serif] text-[12px] leading-[16px] pr-[80px] text-[#000] mb-[.5rem] ml-0">
                                                <span id="mainBalance" className="text-[12px] leading-[16px] text-[#000] cursor-pointer">
                                                    <span className="cmenu">{userBalance?.exposure}</span>
                                                </span>
                                            </dd>
                                        </dl>
                                    </div>
                                    <div className="rounded-[3px] [box-shadow:0_1px_1px_0_rgba(0,_0,_0,_.3)] cursor-pointer ml-[4px] mr-[2px] my-[5px] w-[48%] bg-[#17afc6] border-[1px] border-[solid] border-[#fff]">
                                        <dl className="cursor-pointer pt-[5px] px-[7px] pb-[0] !mb-[.25rem] mt-0">
                                            <dt className="leading-[1.6] mb-[3px] text-[#fff] font-bold">P&amp;L</dt>
                                            <dd className="pb-0 items-center flex font-[Roboto_Condensed,_sans-serif] text-[12px] leading-[16px] pr-[80px] text-[#000] mb-[.5rem] ml-0">
                                                <span id="mainBalance" className="text-[12px] leading-[16px] text-[#000] cursor-pointer">
                                                    <span className="text-[green]" >0.00</span>
                                                </span>
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                                <ul id="account_pop" className="cmenu" >
                                    {
                                        userdata?.user_type == 'User' ? mainMenu.filter(item => item?.type !== 'admins').map((item, index) => (
                                            <li key={index}>
                                                {!item.isLogout ? (
                                                    <Link
                                                        to={item?.url}
                                                        className='cursor-pointer text-[14px] text-[#fff] flex items-center pl-[10px] pr-[8px] py-[8px] no-underline [transition:.3s] hover:[transition:all_.5sease_0s] hover:bg-[#17afc6] hover:text-[#fff]'
                                                        onClick={() => setRightMenu(false)}
                                                    >
                                                        <img alt="" src={item?.icon} className="h-[18px] ml-0 mr-[8px] w-[18px]" />
                                                        {item?.title}
                                                    </Link>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        onClick={() => handleLogout(item)}
                                                        className='cursor-pointer text-[14px] text-[#fff] flex items-center pl-[10px] pr-[8px] py-[8px] no-underline [transition:.3s] hover:[transition:all_.5sease_0s] hover:bg-[#17afc6] hover:text-[#fff] w-full text-left'
                                                    >
                                                        <img alt="" src={item?.icon} className="h-[18px] ml-0 mr-[8px] w-[18px]" />
                                                        {item?.title}
                                                    </button>
                                                )}
                                            </li>
                                        )) : mainMenu.map((item, index) => (
                                            <li key={index}>
                                                {!item.isLogout ? (
                                                    <Link
                                                        to={item?.url}
                                                        className='cursor-pointer text-[14px] text-[#fff] flex items-center pl-[10px] pr-[8px] py-[8px] no-underline [transition:.3s] hover:[transition:all_.5sease_0s] hover:bg-[#17afc6] hover:text-[#fff]'
                                                        onClick={() => setRightMenu(false)}
                                                    >
                                                        <img alt="" src={item?.icon} className="h-[18px] ml-0 mr-[8px] w-[18px]" />
                                                        {item?.title}
                                                    </Link>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        onClick={() => handleLogout(item)}
                                                        className='cursor-pointer text-[14px] text-[#fff] flex items-center pl-[10px] pr-[8px] py-[8px] no-underline [transition:.3s] hover:[transition:all_.5sease_0s] hover:bg-[#17afc6] hover:text-[#fff] w-full text-left'
                                                    >
                                                        <img alt="" src={item?.icon} className="h-[18px] ml-0 mr-[8px] w-[18px]" />
                                                        {item?.title}
                                                    </button>
                                                )}
                                            </li>
                                        ))
                                    }
                                </ul>
                            </Drawer>

                            <div
                                className={`fixed top-0 z-[999999] left-0 h-full w-full bg-white shadow-lg overflow-y-auto transition-transform duration-700 ${leftMenu ? "translate-x-0" : "-translate-x-full"
                                    }`}
                            >
                                <LeftSidebar setLeftMenu={setLeftMenu} />
                            </div>
                        </div>
                    </div>
                </header>
                <section className={`${!userdata ? 'block' : (userdata?.user_type === 'User' ? 'block' : 'hidden lg:block')} h-auto relative w-full bg-[#045662]`}>
                    <nav className='[box-shadow:0_1px_2px_rgba(0,_0,_0,_.2)] h-[55px] lg:h-[40px] w-full bg-[#045662] block'>
                        <div className='items-center flex h-full justify-between m-auto max-w-full p-0 w-full flex-wrap relative'>
                            <div className='h-full leading-[55px] lg:leading-[40px] overflow-auto lg:overflow-visible  z-[999]'>
                                <ul className='flex '>
                                    {
                                        !userdata || userdata?.user_type == 'User' ?

                                            userNavItems.map((item, index) => (
                                                <li key={index} className=' items-center flex justify-between [list-style:none] relative'>
                                                    {/* {'live' in item && <span id="tagLive" className=" tag-live"><strong></strong>{item.live}</span>} */}
                                                    {/* {'img' in item && <span id="tagLive" className="tag-live1"><img className="h-[35px] w-[35px] block mx-[auto] my-[0] text-center" src={item.img} alt="" /></span>} */}
                                                    {/* <button className={`text-[14px] font-bold px-[11px] py-[0] ${item.url == window.location.pathname && !item.highlight ? 'bg-[#5ecbdd]' : ''} text-[#fff] h-full no-underline capitalize whitespace-nowrap ${item.highlight && 'awesome'}`} onClick={() => item?.title == 'Evolution' ? CreateAndLaunchWCOCasino('EVZ', '', 'EV') : navigate(item.url)}>{item.title}</button> */}
                                                    <button className={`text-[14px] font-bold px-[11px] py-[0] ${item.url == window.location.pathname && !item.highlight ? 'bg-[#5ecbdd]' : ''} text-[#fff] h-full no-underline capitalize whitespace-nowrap ${item.highlight && 'awesome'}`} onClick={() => navigate(item.url)}>{item.title}</button>
                                                </li>
                                            ))
                                            :
                                            navItems.map((item, index) => (

                                                <li key={index} className={` items-center lg:flex justify-between [list-style:none] relative hover:bg-[#5ecbdd] ${item.routerId.includes(location.pathname) && !item.highlight ? 'bg-[#5ecbdd]' : ''}`}>
                                                    <div className="dropdown">
                                                        <Link to={item.url ? item.url : 'javascript:void(0);'} className={`text-[14px] font-bold px-[11px] py-[0]  text-[#fff] h-full no-underline capitalize whitespace-nowrap ${item.submenu && 'submenu-toggle'} ${item.highlight && 'awesome'}`}>{item.title}</Link>
                                                        {item.submenu && (
                                                            <ul className="dropdown-content">
                                                                {item.submenu && (
                                                                    <ul className="dropdown-content">
                                                                        {item.submenu.map((item, index) => (
                                                                            <li key={index} className='float-none border-b-[1px] border-b-[#383838] border-r-[1px] border-r-[#797777] block'>
                                                                                <Link to={item.url ? item.url : 'javascript:void(0);'} className='text-[white] font-bold text-[0.813rem] px-[10px] py-[0] block no-underline cursor-pointer hover:bg-[#5ecbdd] hover:underline'>
                                                                                    {item.title}
                                                                                </Link>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                )}
                                                            </ul>
                                                        )}                                                    </div>
                                                </li>
                                            ))
                                    }
                                    {!userdata || userdata?.user_type !== 'User' &&
                                        <li className={`flex px-[10px] py-[0] leading-[30px] lg:absolute right-[50px] top-[5px]`} >
                                            <div className="dropdown">
                                                <button type="button" className={`flex items-center gap-[3px] text-[14px] font-bold px-[11px] py-[0]  text-[#fff] h-full no-underline capitalize whitespace-nowrap `}
                                                    onClick={() => {
                                                        dispatch(logout());
                                                        navigate('/');
                                                    }}
                                                >Logout
                                                    <svg width="10" height="11" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5.71 7.706l1.432-1.604H1.778V4.898h5.39L5.71 3.294l.781-.86L9.278 5.5 6.49 8.565l-.78-.86zM1.12 0C.825 0 .564.124.339.372a1.24 1.24 0 0 0-.339.86v8.536c0 .325.113.611.339.86.225.248.486.372.78.372H8.88c.295 0 .556-.124.781-.372a1.24 1.24 0 0 0 .339-.86V7.333H8.88v2.435H1.12V1.232h7.76v2.435H10V1.232a1.24 1.24 0 0 0-.339-.86C9.436.124 9.175 0 8.881 0H1.12z" fill="currentColor" fillRule="evenodd"></path>
                                                    </svg>
                                                </button>
                                            </div>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </nav>
                </section>
            </div >
        </>
    );
}


export default Header;
